import React from "react";
import badgeImg from "../../assets/img/brand/fhp-badge.jpg";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import { IoMdArrowBack } from "react-icons/io";
import { Button, Container } from "reactstrap";
import { FaYoutube } from "react-icons/fa6";
import img from "../../assets/img/custom/page_1.png";

const SchoolLicence = () => {
  return (
    <div className="bg-white ">
      <button type="button" className="text-white btn btn-primary mx-4 my-3" onClick={() => window.history.back()}>
        <IoMdArrowBack /> Go Back
      </button>{" "}
      <Container>
        <h4 className="m-3 px-sm-3">
          FHP Mementos can be even more exciting with video of game action. Use
          of such game video requires the athlete's SCHOOL to sign a license
          agreement for the IP rights. By the agreement, FHP will pay the school
          a share of Memento proceeds to allow Athletes to use the school’s
          Intellectual Property in the photos and videos and text of the
          MEMENTOS.
        </h4>
        <h4 className="text-center textUnderline">
          To review the agreement, School Administrators can follow the
          instructions provided below.
        </h4>
        <div className=" d-flex justify-content-center mb-5 licenceBtn">
          <div className=" Administrator mx-2">
            <h4>ADMINISTRATOR</h4>
          </div>
          <div className=" licenceInnerBtn">
            <Button color="primary" className="my-2 mx-1 d-sm-block">
              INSTRUCTIONS
            </Button>
            <Button color="primary " className="my-sm-2 d-sm-block mx-auto">
              GET STARTED
            </Button>
          </div>
          <div className=" help mx-2">
            <h4>HELPS</h4>
          </div>
        </div>
        {/* <div className="text-center">
          <img src={img} alt="Under construction" className="img-fluid" />
        </div> */}
      </Container>
    </div>
  );
};

export default SchoolLicence;
